(function () {

  function initArticleTOC(root) {

    root = root || document;


    var layouts =
      root.querySelectorAll(
        '[data-article-toc-layout]'
      );


    layouts.forEach(function (layout) {


      /*
       * Prevent duplicate initialization
       */

      if (
        layout.dataset.tocInitialized === 'true'
      ) {
        return;
      }


      var content =
        layout.querySelector(
          '[data-article-toc-content]'
        );


      var sidebar =
        layout.querySelector(
          '[data-article-toc-sidebar]'
        );


      var nav =
        layout.querySelector(
          '[data-article-toc-nav]'
        );


      var disclosure =
        layout.querySelector(
          '[data-article-toc-disclosure]'
        );


      if (
        !content ||
        !sidebar ||
        !nav
      ) {
        return;
      }


      /*
       * Detect H2 - H6
       */

      var headings =
        Array.prototype.slice.call(
          content.querySelectorAll(
            'h2, h3, h4, h5, h6'
          )
        );


      /*
       * Remove empty headings
       */

      headings =
        headings.filter(
          function (heading) {

            return (
              heading
                .textContent
                .trim()
                .length > 0
            );

          }
        );


      /*
       * No headings:
       * don't display TOC
       */

      if (!headings.length) {

        layout.dataset.tocInitialized =
          'true';

        return;

      }


      /*
       * Existing IDs
       */

      var usedIds =
        new Set();


      document
        .querySelectorAll('[id]')
        .forEach(
          function (element) {

            if (element.id) {
              usedIds.add(element.id);
            }

          }
        );


      /*
       * Generate anchor slug
       */

      function createSlug(text) {

        var slug =
          text
            .toLowerCase()
            .trim()
            .normalize('NFKD')
            .replace(
              /[\u0300-\u036f]/g,
              ''
            )
            .replace(
              /[^a-z0-9\u4e00-\u9fff]+/g,
              '-'
            )
            .replace(
              /^-+|-+$/g,
              ''
            );


        if (!slug) {
          slug = 'section';
        }


        var originalSlug = slug;

        var counter = 2;


        while (
          usedIds.has(slug)
        ) {

          slug =
            originalSlug +
            '-' +
            counter;

          counter++;

        }


        usedIds.add(slug);

        return slug;

      }


      var tocItems = [];


      /*
       * Responsive disclosure
       */

      var desktopMedia =
        window.matchMedia(
          '(min-width: 1200px)'
        );


      function syncDisclosure() {

        if (!disclosure) {
          return;
        }


        if (
          desktopMedia.matches
        ) {

          /*
           * Desktop:
           * always open
           */

          disclosure.open = true;

        } else {

          /*
           * Mobile / tablet:
           * closed by default
           *
           * Only close automatically
           * when switching breakpoint.
           */

          disclosure.open = false;

        }

      }


      /*
       * Apply initial state
       */

      syncDisclosure();


      /*
       * Change when crossing breakpoint
       */

      if (
        desktopMedia.addEventListener
      ) {

        desktopMedia.addEventListener(
          'change',
          syncDisclosure
        );

      } else {

        desktopMedia.addListener(
          syncDisclosure
        );

      }


      /*
       * Generate TOC links
       */

      headings.forEach(
        function (heading) {


          if (!heading.id) {

            heading.id =
              createSlug(
                heading.textContent
              );

          }


          var level =
            heading
              .tagName
              .replace('H', '');


          var link =
            document.createElement(
              'a'
            );


          link.className =
            'article-toc-link';


          link.dataset.level =
            level;


          link.href =
            '#' + heading.id;


          link.textContent =
            heading
              .textContent
              .trim();


          /*
           * Click navigation
           */

          link.addEventListener(
            'click',
            function (event) {

              event.preventDefault();


              var isMobile =
                window.matchMedia(
                  '(max-width: 1199px)'
                ).matches;


              /*
               * Close TOC first on mobile
               * so scroll position remains accurate
               */

              if (
                isMobile &&
                disclosure
              ) {

                disclosure.open = false;

              }


              /*
               * Wait for layout to collapse,
               * then scroll
               */

              window.requestAnimationFrame(
                function () {

                  heading.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                  });


                  /*
                   * Update URL
                   */

                  if (
                    history.pushState
                  ) {

                    history.pushState(
                      null,
                      '',
                      '#' +
                      encodeURIComponent(
                        heading.id
                      )
                    );

                  }

                }
              );

            }
          );


          nav.appendChild(link);


          tocItems.push({
            heading: heading,
            link: link
          });

        }
      );


      /*
       * Show TOC
       */

      sidebar.hidden = false;

      layout.classList.add(
        'toc-ready'
      );


      /*
       * Active heading
       */

      function updateActiveHeading() {

        var currentHeading =
          headings[0];


        var offset = 160;


        headings.forEach(
          function (heading) {

            var rect =
              heading
                .getBoundingClientRect();


            if (
              rect.top <= offset
            ) {

              currentHeading =
                heading;

            }

          }
        );


        tocItems.forEach(
          function (item) {


            var isActive =
              item.heading ===
              currentHeading;


            item.link
              .classList
              .toggle(
                'is-active',
                isActive
              );


            if (isActive) {

              item.link
                .setAttribute(
                  'aria-current',
                  'location'
                );

            } else {

              item.link
                .removeAttribute(
                  'aria-current'
                );

            }

          }
        );

      }


      /*
       * Efficient scroll listener
       */

      var ticking = false;


      function handleScroll() {

        if (!ticking) {

          window
            .requestAnimationFrame(
              function () {

                updateActiveHeading();

                ticking = false;

              }
            );


          ticking = true;

        }

      }


      window.addEventListener(
        'scroll',
        handleScroll,
        {
          passive: true
        }
      );


      updateActiveHeading();


      /*
       * Theme editor cleanup
       */

      layout._tocCleanup =
        function () {


          window.removeEventListener(
            'scroll',
            handleScroll
          );


          if (
            desktopMedia
              .removeEventListener
          ) {

            desktopMedia
              .removeEventListener(
                'change',
                syncDisclosure
              );

          } else {

            desktopMedia
              .removeListener(
                syncDisclosure
              );

          }

        };


      layout.dataset.tocInitialized =
        'true';

    });

  }


  /*
   * Normal page load
   */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        initArticleTOC(
          document
        );

      }
    );

  } else {

    initArticleTOC(
      document
    );

  }


  /*
   * Shopify Theme Editor
   */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initArticleTOC(
        event.target
      );

    }
  );


  document.addEventListener(
    'shopify:section:unload',
    function (event) {


      var layouts =
        event.target
          .querySelectorAll(
            '[data-article-toc-layout]'
          );


      layouts.forEach(
        function (layout) {

          if (
            typeof
              layout._tocCleanup ===
              'function'
          ) {

            layout
              ._tocCleanup();

          }

        }
      );

    }
  );

})();